import { SystemSettingsState } from "@/models/SystemSettingsState";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

const state: SystemSettingsState = {
registrationEnabled:false,
userManualVideoEnabled:false,
usersAutoEnrollmentEnabled:false,
userHelpButtonEnabled:false,
};

export default {
    state,
    getters,
    mutations,
    actions
};
